import api from './api';

export default async function updateKeyword(id, body) {
    const { data } = await api.put(`misspelling-keyword/${id}`, body);

    return data;
}